export function created() {
  return {
    label: 'Created',
    getter: (row) => formatDate(row.created)
  };
}

export function updated() {
  return {
    label: 'Updated',
    getter: (row) => formatDate(row.updated)
  };
}

export function formatDate(date) {
  return new Date(date).toLocaleString();
}
